module.exports = __webpack_public_path__ + "static/media/return-home.9b5b3df5.svg";